<template>
  <div>
    <div>
      <el-carousel trigger="hover" height="800px" :interval="12000">
        <el-carousel-item v-for="(item, bannarDesc) in imgList">
          <img v-bind:src="api + item.bannarUrl"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="lowerbox">
      <div class="cpb">
        <div class="lanmu1box1" v-for="(item,index) in lanmu1Data" @click="menuList(item,item.menuId,item,childIndex)">
<!--          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>-->
          <div class="cpname">
            <div class="lanmu1name1" :style="{ backgroundImage: `url(${api}${item.icon})` }">
<!--              {{item.menuName}}-->
              </div>
            <!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">点击查看详情</div>
          </div>
        </div>
      </div>

<!--      <div class="lanmu1">
        <div class="lanmu11">建筑工程重大安全及质量安全赔偿案例摘录</div>
      </div>-->
      <div class="cpb">
        <div class="lanmu1box2" v-for="(item,index) in lanmu2Data" @click="menuList(item,item.menuId,item,childIndex)">
<!--                    <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>-->
          <div class="cpname">
            <div class="lanmu1name2" :style="{ backgroundImage: `url(${api}${item.icon})` }">
<!--              {{item.menuName}}-->
              <br></div>
            <!--            <div>{{ item.productName }}</div>-->
                        <div class="detailbox">点击查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">
<!--      <div class="mlbox">-->
<!--        <div>建筑用胶粘剂产品世界</div>-->
<!--        <div class="pctitle">BUILDING ADHESIVES PRODUCTS WORLD</div>-->
<!--      </div>-->
      <div class="cpb">
        <div class="cpbox" v-for="(item,index) in listData" @click="openDetails(item,index,'name1')">
          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>
          <div class="cpname">
<!--        <div class="titleName">{{item.menuName}} </div>-->
<!--            <div>{{ item.productName }}</div>-->
            <div class="detailbox">点击查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lowerbox">

      <div class="lanmu3">
        <img src="../../static/img/chenxiang.png" style="width: 100%; height: 100%;">
      </div>
      <div class="cpb">
        <div class="lanmu3box" v-for="(item,index) in lanmu3Data" @click="openfangshui(item.url)">
          <!--          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>-->
          <div class="cpname">
            <div class="lanmu3name" :style="{ backgroundImage: `url(${api}${item.icon})` }"><p class="namep3">
<!--              {{item.menuName}}-->
            </p></div>
            <!--            <div>{{ item.productName }}</div>-->
            <!--            <div class="detailbox">查看详情</div>-->
          </div>
        </div>
      </div>

      <div class="lanmu3">
        <img src="../../static/img/jiuchen.png" style="width: 100%; height: 100%;">

      </div>
      <div class="cpb">
        <div class="lanmu3box" v-for="(item,index) in lanmu4Data" @click="openfangshui(item.url)">
          <!--          <div class="cpsimg"><img :src="api + item.icon" class="cpimg" alt=""></div>-->
          <div class="cpname">
            <div class="lanmu3name"  :style="{ backgroundImage: `url(${api}${item.icon})` }"><p class="namep3" >
<!--              {{item.menuName}}-->
            </p>
              </div>
            <!--            <div>{{ item.productName }}</div>-->
            <!--            <div class="detailbox">查看详情</div>-->
          </div>
        </div>
      </div>
    </div>


    <div class="lowerbox">
      <div class="mlbox">
        <div>企业中心</div>
        <div class="pctitle">ENTERPRISE CENTER</div>
      </div>
      <div class="jsbox" @click="opensl()">
<!--        <div class="imgbox"></div>
        <div class="introduce">
          <div class="cenbox">湖南神力胶业集团</div>
          <div class="textbox">创建于1989年，专业从事有机高分子化合胶粘剂研发/生产/贸易于一体的企业，主要生产石材胶和其他粘胶剂</div>
          <div class="textbox">
            湖南神力胶业集团创建于1989年11月，是一家专业从事有机高分子化合胶粘剂研发、生产、贸易于一体且具有全部自主知识产权的企业。总部座落在长沙国家生物医药园(浏阳工业园)。紧靠319国道，东距长沙市36公里，离长沙市黄花国际机场20公里。公司占地面积19800平方米，地处长浏、岳汝、昌平、浏大四条高速公路交界处，长、株、潭城际轻轨贯穿全境，交通便利。优美的自然环境、便捷的交通环境、高速发展的人文科技环境，孕育出了这家蓝色、漂亮、齐整的现代化企业。神力荣耀成为世界花炮之都浏阳又一崭新的名片。
          </div>
          <div class="more" @click="opensl()">了解更多</div>
        </div>-->
      </div>
    </div>
    <div class="lowerbox">
      <div class="mlbox">
        <div>董事长寄语</div>
        <div class="pctitle">Chairman message</div>
      </div>
      <div class="dszbox"> </div>
    </div>
    <div class="lowerbox widthbox">
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in newsList1"
                   @click="newsDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in newsTitle">
            <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>{{ item.menuName }}</div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flexbox">
      <div class="flexImg"><img src="../../static/img/home1.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home2.png" alt=""></div>
      <div class="flexImg"><img src="../../static/img/home3.png" alt=""></div>
    </div>
<!--    <div class="lowerbox widthbox">-->
<!--      <div class="mlbox">-->
<!--        <div>新闻中心</div>-->
<!--        <div class="pctitle">ENTERPRISE CENTER</div>-->
<!--      </div>-->
<!--      <div class="newsboxs">-->
<!--        <div class="newsbigbox">-->
<!--          <div>-->
<!--            <img src="../../static/img/img.jpg" alt="" style="width: 100%">-->
<!--          </div>-->
<!--          <div class="newbox1" @click="menuList(this.oneNewTitle,this.oneNewTitle.menuId,this.oneNewTitle,this.oneNewTitle.childIndex)">-->
<!--            {{oneNewTitle.menuName}}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="newbox2" >-->
<!--          <div class="titlebox1" v-for="(item,childIndex) in newsTitle">-->
<!--              <div class="timebox">-->
<!--                <div class="daybox">{{ item.createTime.slice(8,10) }}</div>-->
<!--                <div class="nianbox">{{ item.createTime.slice(0,7) }}</div>-->
<!--              </div>-->
<!--            <div class="titles" @click="menuList(item,item.menuId,item,childIndex)">{{ item.menuName }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="lowerbox widthbox">
      <div class="flexsbox">
        <div style="width: 100%;min-height: 500px">
          <div class="flexsbox">
            <div class="newtit">
              <div>新闻中心</div>
              <div class="pctitle">NEWS CENTER</div>
            </div>
            <div class="tabbox">
              <div :class="{'active':active_btn==index}" v-for="(item,index) in newsList1"
                   @click="newsDetails(index,item)">{{item.menuName}}
              </div>
            </div>
          </div>
          <div class="newDetail">
            <div>
              <img src="../../static/img/054fdf4d7b696fca412a802db1694c1.jpg" style="width: 100%; max-width: 550px " alt="">
            </div>
          </div>
          <div class="newtext">
          <div class="newbox" v-for="(item,childIndex) in newsTitle">
            <div class="newtitle" @click="menuList(item,item.menuId,item,childIndex)"><span class="spot">·</span>{{ item.menuName }}</div>
          </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
let api = 'https://www.slfangshuijiao.com/api';
let deptId = 112;
export default {
  name: 'Shouye',
  data() {
    return {
      newsTitle: [],
      oneNewTitle: [],
      newsList: [],
      newsList1: [],
      newsList2: [],
      active_btn: 0,
      activeName: 'first',
      imgList: [],
      listData: [],
      lanmu1Data:[],
      lanmu2Data:[],
      lanmu3Data:[],
      lanmu4Data:[],
      menuId:'',
      name1:'',
      name2:'',
      //产品分页
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        type: '',
        gjz: '',
      },
      api,
    }
  },
  created() {

  },
  mounted() {
    this.lbList()
    this.newList()
    // this.zxSubmit()
  },
  methods: {
    //了解更多跳转
    opensl(){
      console.log(111)
      window.location = '/#/ejml?id=18&name=走进神力';
      document.documentElement.scrollTop = 0;
    },
    //跳转神力防水网站
    openfangshui(url){
      window.open(url);
    },
    //打开文件
    openFile(item){
      window.open(api + item.target)
    },
      openUrl(item){
      if (item.menuType == 'D'){
        window.location = '/#/cplist?id=' + item.menuId + '&name=' + encodeURI(item.menuName) + '&menuId=' + item.menuId;
      }
    },
    //跳转产品详情页面
    openDetails(item,index,name) {
      console.log(666,item,index,name,this.name1,this.name2);
      if (name == 'name1'){
        name = this.name1
      }else {
        name = this.name2
      }
      let menuId = ''
      if (item.children){
        menuId = item.children[0].menuId
        if (item.children[0].children){
          menuId = item.children[0].children[0].menuId
        }
      }else {
        menuId = item.menuId
      }
      var url = "/#/cplist?id=" + item.parentId + '&name=产品世界'+ '&index=' + index +
          '&titName=' +''+ '&menuId=' + item.menuId

      console.log('url----',url);
      window.location = url
      // window.location = "/#/cpdetails?id=" + item.productId + '&name=' + encodeURI(item.productName)
    },
    newsDetails(index, items) {
      console.log('点击',items);
      this.newsList1.forEach(item => {
        if (item.menuName == items.menuName) {
          this.newsTitle = item.children
        }
      })
      this.active_btn = index
    },
    handleClick(tab, event) {
    },
    //新闻列表
    newList() {
      let that = this;
      that.$axios.post(api + '/site/columnList', {
        deptId: deptId
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.newsList = that.handleTree(res.data.data, 'menuId', 'parentId')
            console.log(6666,that.newsList);
            //建筑用胶粘剂产品世界数据
            that.newsList.forEach(item=>{
              if (item.menuName == '产品世界'){
                that.listData = item.children
                that.menuId = item.menuId
                that.name1 = item.children[0].menuName
                that.name2 = item.children[1].menuName
              }
              if (item.menuName == '黑色区域1'){
                that.lanmu1Data = item.children
              }if (item.menuName == '黑色区域2'){
                that.lanmu2Data = item.children
              }
              if (item.menuName == '第三区域顶部'){
                that.lanmu3Data = item.children
              }if (item.menuName == '第三区域下部'){
                that.lanmu4Data = item.children
              }
            })
            console.log('建筑用胶粘剂产品世界数据',that.listData);
            var newArr1 = []
            // var newArr2 = []
            that.newsList.forEach(item => {
              if (item.visible == 1 && item.menuName !== '黑色区域2' && item.menuName !== '黑色区域1'&& item.menuName !== '第三区域顶部' && item.menuName !== '第三区域下部'){
                newArr1.push(item)
              }
            })
            that.newsList1 = newArr1
            console.log(1111,newArr1)
            if (newArr1) {
              that.oneNewTitle = newArr1[0].children[0]

              newArr1[0].children.forEach((item,index)=>{
                // if (index > 0 && index<5){
                  item.createTime = item.createTime.slice(0,10)
                  that.newsTitle.push(item)
                // }
              })
            }
            console.log('shuju',newArr1[0].children,that.newsTitle);
            console.log('一条',that.oneNewTitle);
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },

    //二级跳转方法
    menuList(item1, id, item2, index) {
      console.log('跳转信息', item1, item2, index);
      // return
      let that = this;
      that.$axios.post(api + '/site/columnDetail', {
        columnId: id
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (item1.menuType === 'D') {
            window.open('/#/cplist?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + index + '&menuId=' + item2.menuId)
          } else if (item1.menuType === 'C') {
            // console.log(111111,item1.target)
            if(item1.target != ''){
              window.open(api + item1.target)
            }
            // window.location = '/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&target=' + item1.target + '&index=' + 0;
            // document.documentElement.scrollTop = 0;
            // window.location.reload();
          } else if (res.data.data.length > 0) {
            if (item1.menuType === 'F' && item1.perms == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M' && item1.children == '') {
              that.$message('暂无数据');
              return
            } else if (item1.menuType === 'M') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0);
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            } else if (item1.menuType === 'F') {
              window.open('/#/ejml?id=' + item2.menuId + '&name=' + encodeURI(item2.menuName) + '&index=' + 0) ;
              // document.documentElement.scrollTop = 0;
              // window.location.reload();
            }
          }
        } else {
          that.$message.error(res.message);
        }
      })

    },

    // 轮播图列表
    lbList() {
      let that = this;
      let num =0
      if (screen.width > 765){
        num=1
      }else{
        num=2
      }
      that.$axios.post(api + '/site/bannarList', {
        deptId: deptId,
        bannarType:num
      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        // console.log('轮播',res)
        if (res.data.code == '0') {
          if (res.data.data) {
            console.log(res.data.data)
            that.imgList = res.data.data
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },
    //产品列表
    /*zxSubmit() {
      let that = this;
      that.$axios.post(api + '/site/productList', {
        columnId: 133,
        deptId:deptId,
        pageNum: this.queryParams.pageNum,
        pageSize: this.queryParams.pageSize,
        param: this.queryParams.gjz,

      },{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(function (res) {
        if (res.data.code == '0') {
          if (res.data.data) {
            that.listData = res.data.data.rows
            console.log(22222222123,that.listData);
            that.listData.forEach(item => {
              item.productPhoto = item.productPhoto.split(',')
            })
            that.total = res.data.data.total
          }
        } else {
          that.$message.error(res.message);
        }
      })
    },*/
    //树形转换
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
      };

      var childrenListMap = {};
      var nodeIds = {};
      var tree = [];

      for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
      }

      for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
          tree.push(d);
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t);
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c);
          }
        }
      }

      return tree;
    },
  }
}
</script>
<style scoped>
.lanmu1{
  /*background-image:url("../../static/img/1.png") ;*/
  text-align: center;
  font-size: 32px;
}
.lanmu11{
  background-image:url("../../static/img/3.png") ;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  align-content: center;
  height: 186px;
  color: #FFFFFF;
  font-weight: bold;
  margin: 0 53px;
}
.lanmu1name1{
  background-image: url("../../static/img/blackBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
  font-size: 19px;
  font-weight: bold;
  width: 310px;
  height: 110px;
  align-content: center;
  padding: 0 10px;
}
.lanmu1name2{
  background-image: url("../../static/img/blackBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;
  font-size: 19px;
  font-weight: bold;
  width: 520px;
  height: 115px;
  align-content: center;
  padding: 0 10px;
}
.lanmu1box1{
  width: calc(100% / 5 );
  float: left;
  /*margin: 15px;*/
  cursor: pointer;
}
.lanmu1box2{
  width: calc(100% / 3 - 35px);
  float: left;
  margin: 15px;
  cursor: pointer;
}
.lanmu3{
  /*background-image:url("../../static/img/1.png") ;*/
  text-align: center;
  font-size: 32px;
}
.lanmu33{
  background-image:url("../../static/img/redLongBg.png") ;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  align-content: center;
  height: 165px;
  width: 1650px;
  margin: auto;
  color: #FFFFFF;
  font-weight: bold;
}

.lanmu3name{
  background-image: url("../../static/img/redBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 115px;
  color: #fff;
  font-size: 19px;
  font-weight: bold;
  width: 520px;
  align-content: center;
  padding: 0 10px;
}
.lanmu3box{
  width: calc(100% / 3 - 0px);
  float: left;
  /*margin: 15px 52px 0 52px;*/
  cursor: pointer;
}
.spot {
  color: #008D40;
  padding: 0 5px;
  width: 20px;
  height: 20px;
  border-radius: 50px;
}
.newtitle:hover{
  color: #008D40;
}
.widthbox {
  height: 520px;
}

.newcontent {
  color: #989898;
  font-size: 14px;
  padding: 15px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newtitle {
  font-weight: 600;
  cursor: pointer;
}
.flexbox{
  padding: 40px 0;
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  margin-left: 190px;
}
.flexmIg{
  width: calc(100% / 3);
  text-align: center;
}
.flexImg img{
  width: 70%;
}
.newbox {
  padding: 15px 0;
}
.newtext{
  max-height:315px;
  overflow: auto;
  padding: 0 55px;
}
.newDetail {
  float: left;
  /*width: calc(100% - 50%);*/
  padding: 15px;
}

.borbox {
  width: 30%;
  border-left: solid 1px #CACACA;
}

.titbox {
  padding: 0 15px;
  cursor: pointer;
}

.active {
  border: solid 1px #4da9ce;
  background: #4da9ce;
  color: #fff;
  border-radius: 2px;
  font-weight: 600;
}

.tabbox div {
  border: solid 1px #CACACA;
  padding: 10px 15px;
  cursor: pointer;
  font-weight: 600;
  width: 15% !important;
  margin-bottom: 15px;
  text-align: center !important;
}

.news {
  border-left: solid 1px #CACACA;
  padding: 15px;
  font-weight: 600;
  width: 30%;

}

.new div {
  color: #009444;
}

.newtit {
  border-left: solid 5px #008D40;
  height: 43px;
  padding: 0px 10px;
  font-size: 20px;
}

.tabbox {
  width: 100%;
  display: flex;
  padding: 15px 0;
  justify-content: space-between;
  max-height: 220px;

}

.flexsbox {
  display: flex;
}

.more {
  color: #06A0F6;
  float: right;
  font-size: 16px;
  cursor: pointer;
}

.textbox {
  text-indent: 2em;
  line-height: 2.2;
}

.cenbox {
  text-align: center;
  padding: 15px;
  font-weight: 600;
}

.jsbox {
  width: 100%;
  display: flex;
  background-image: url("../../static/img/homeQyzx1.jpg");
  background-size: 100% 100%;
  height: 1270px;
  margin: 15px 0;
}
.dszbox{
  display: flex;
  background-image: url("../../static/img/homeDsz1.jpg");
  background-size: 100% 100%;
  height: 600px;
}
.introduce {
  background: #FFFFFF;
  padding: 15px;
  height: 350px;
  margin-top: 40px;
  border-radius: 15px;
  margin-left: -200px;
  width: 700px;
  z-index: 2;
}

.imgbox {
  margin: 15px 0 0px 40px;
  width: 60%;
  height: 400px;
  /*z-index:1;*/
  /*position: absolute;*/
  background-image: url("../../static/img/img.jpg");
  background-size: 100% 100%;
}

.lowerbox {
  background-color: #F5F5F5;
  padding: 25px;
  margin: 15px;
  margin-left: 3%;
  width: 90%;
}

.mlbox {
  border-left: solid 5px #00AFFF;
  padding: 0px 10px;
  font-size: 20px;
  font-weight: 600;
}

.pctitle {
  font-size: 10px;
}

.cpb {
  padding: 15px 0;
  overflow: auto;
}


.cpbox {
  width: calc(100% / 3 - 35px);
  float: left;
  margin: 15px;
  cursor: pointer;
}
.cpsimg{
  text-align: center;
}
.cpimg {
  height: 115px;
  width: 520px;
  object-fit: 100% 100%;
}

.cpname {
  background-color: #F7F7F7;
  text-align: center;
}
.detailbox{
  font-size: 14px;
  background-color:#4da9ce;
  width: 110px;
  margin: 14px auto;
  border-radius: 5px;
  color: rgb(255, 255, 255);
  padding: 5px;
}
.xqbox {
  color: rgb(158, 159, 159);
  font-size: 12px;
}
@media screen and (max-width: 500px) {
  .cpname{
    padding: 0px 0 10px;
  }
  .lanmu1{
    /*background-image:url("../../static/img/1.png") ;*/
    text-align: center;
    font-size: 16px;
  }
  .lanmu11{
    background-image:url("../../static/img/sj3.png") ;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    align-content: center;
    height: 112px;
    color: #FFFFFF;
    font-weight: bold;
    margin: 0 0px;
    width: 100%;
  }
  /*.lanmu1name{
    background-image: url("../../static/img/sj1.png");
    background-size: cover;
    background-repeat: no-repeat;
    height: 85px;
    color: #fff;
    font-size: 11px;
    font-weight: bold;
    width: 150px;
    align-content: center;
  }*/
  .lanmu1box{
    width: calc(100% / 2 - 35px);
    float: left;
    margin: 15px;
    cursor: pointer;
  }
  .lanmu3{
    /*background-image:url("../../static/img/1.png") ;*/
    text-align: center;
    font-size: 25px;
  }

  .lanmu3box{
    width: calc(100% / 2 - 0px);
    float: left;
    margin: 0px;
    cursor: pointer;
  }
  .namep3{
    padding: 0 15px;
    font-family: "华康行楷体W5";
  }
  .newsbigbox{
    width: 100%  !important;
  }
  .newsboxs{
    display: block;
  }
  .newbox2{
    width: 100%;
    padding: 0px;
  }
  .widthbox{
    height: 100%;
  }
  .flexsbox{
    display: block!important;
    overflow: hidden !important;
  }
  .newtext{
    overflow: auto;
    max-height: 320px;
    padding: 15px;
  }
  .flexbox{
    margin-left: 0px;
    padding: 0;
    display: block;
    width: 90% !important;
    margin: auto;
  }
  .flexbox div{
    margin-bottom: 15px;
  }
  .flexImg img{
    width: 100% !important;
  }
  .phoneImg{
    display: block;
  }
  .tabbox {
    width: calc(100% - 5px);
    padding: 30px 0;
    justify-content: flex-start;
    margin-left: 0px;
}
  .active{
    /*padding: 5px;*/
  }
  .tabbox div {
    padding: 3px 15px;
    cursor: pointer;
    font-weight: 600;
    width: 33% !important;
  }
  .introduce{
    background: #FFFFFF;
    padding: 15px;
    height: 350px;
    margin-top: -122px;
    border-radius: 15px;
    margin-left: 0px;
    width: 330px;}
  .imgbox {
    margin: 15px 0 90px 15px;
    width: 95%;
    height: 150px;
    border-radius: 15px;
    /*z-index:1;*/
    /*position: absolute;*/
    background-image: url("../../static/img/img.jpg");
    background-size: 100% 100%;
  }
  .jsbox{
    display:block;
    background-image: url("../../static/img/homeQyzx2.jpg");
  }
  .dszbox{
    width: 100%;
    background-image: url("../../static/img/homeDsz2.jpg");
  }
}
</style>
